import { render } from "./Tracker.vue?vue&type=template&id=2bb80874"
import script from "./Tracker.vue?vue&type=script&lang=js"
export * from "./Tracker.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jarre\\OneDrive\\Desktop\\MSD\\msd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__